module.exports = __webpack_public_path__ + "static/img/xiazai.3b0c70d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiazai.gif
// module id = X3oI
// module chunks = 0